@if((footerLinks | async)?.length > 0)
{
    <ul id="footer-menus">
        <nav>
            <ul id="footer-menu-center">
                <li *ngFor="let link of footerLinks | async">
                    <ng-container *ngIf="link.linkType === 1">
                        <a [routerLink]="link.url">{{ link.description }}</a>
                    </ng-container>
                    <ng-container *ngIf="link.linkType === 2">
                        <a [href]="link.url" target="_blank">{{ link.description }}</a>
                    </ng-container>
                    <ng-container *ngIf="link.linkType === 3">
                        <a [href]="'mailto:' + link.url" target="_blank">{{ link.description }}</a>
                    </ng-container>
                    <ng-container *ngIf="link.linkType === 4">
                        <a [routerLink]="['/page', link.url]">{{ link.description }}</a>
                    </ng-container>
                    <ng-container *ngIf="link.linkType === 0">
                        <span class="inactive-link">{{ link.description }}</span>
                    </ng-container>
                </li>
            </ul>
        </nav>
    </ul>    
}

@if((institutionalLogos | async)?.length > 0)
{
    <ul id="footer-logos-main">
        <li *ngFor="let logo of institutionalLogos | async">
            <div style="height: 80px;">
                <ng-container *ngIf="logo.url != null; else noLink">
                    <a [href]="logo.url" class="footer-logo" [style]="'display:inline-block; height: ' + ((logo.imageHeight ?? 1) * 100) + '%;'" [target]="logo.isExternal ? '_blank' : '_self'"><img style="height: 100%;" [src]="logo.imageUrl" [alt]="logo.title"></a>
                </ng-container>
                <ng-template #noLink>
                    <img class="footer-logo" [style]="'height: ' + ((logo.imageHeight ?? 1) * 100) + '%;'" [src]="logo.imageUrl" [alt]="logo.title">
                </ng-template>
            </div>
        </li>
    </ul>
}

@if((partnersLogos | async)?.length > 0)
{
    <ul id="footer-logos-partners">
        <li *ngFor="let logo of partnersLogos | async">
            <div style="height: 60px;">
                <ng-container *ngIf="logo.url != null; else noLink">
                    <a [href]="logo.url" class="footer-logo" [style]="'display:inline-block; height: ' + ((logo.imageHeight ?? 1) * 100) + '%;'" [target]="logo.isExternal ? '_blank' : '_self'"><img style="height: 100%;" [src]="logo.imageUrl" [alt]="logo.title"></a>
                </ng-container>
                <ng-template #noLink>
                    <img class="footer-logo" [style]="'height: ' + ((logo.imageHeight ?? 1) * 100) + '%;'" [src]="logo.imageUrl" [alt]="logo.title">
                </ng-template>
            </div>
        </li>
    </ul>
}


